import { BrandGradientDefs, type IllustrationProps, Sparkle } from "./common";

export function EmptyChat({ size = 120, ...props }: IllustrationProps): JSX.Element {
  return (
    <svg
      viewBox="0 0 200 200"
      width={size}
      height={size}
      fill="none"
      aria-hidden
      {...props}
    >
      <BrandGradientDefs id="ec" />
      {/* User bubble (smaller, right) */}
      <rect
        x="100"
        y="48"
        width="76"
        height="36"
        rx="14"
        fill="url(#ec-fill)"
        stroke="url(#ec-stroke)"
        strokeWidth="1.5"
        opacity="0.7"
      />
      <circle cx="118" cy="66" r="2" fill="url(#ec-stroke)" />
      <circle cx="138" cy="66" r="2" fill="url(#ec-stroke)" />
      <circle cx="158" cy="66" r="2" fill="url(#ec-stroke)" />
      {/* Assistant bubble (larger, left) */}
      <rect
        x="24"
        y="106"
        width="110"
        height="56"
        rx="14"
        fill="hsl(var(--background))"
        stroke="url(#ec-stroke)"
        strokeWidth="2"
      />
      <rect x="40" y="120" width="60" height="5" rx="2.5" fill="url(#ec-stroke)" opacity="0.7" />
      <rect x="40" y="134" width="78" height="4" rx="2" fill="hsl(var(--muted-foreground))" opacity="0.4" />
      <rect x="40" y="146" width="48" height="4" rx="2" fill="hsl(var(--muted-foreground))" opacity="0.4" />
      {/* AI orb in corner */}
      <circle cx="160" cy="146" r="14" fill="url(#ec-fill)" />
      <circle cx="160" cy="146" r="14" stroke="url(#ec-stroke)" strokeWidth="2" fill="none" strokeDasharray="6 3" />

      <Sparkle cx={184} cy={32} size={9} />
      <Sparkle cx={36} cy={86} size={6} opacity={0.5} />
      <Sparkle cx={172} cy={120} size={5} opacity={0.6} />
    </svg>
  );
}
